import { CopyrightWrapper } from "./Copyright.stitches";

const Copyright = (props) => {
  const copyrightText = "©2026 Stephanie Hays";
  return <CopyrightWrapper>{copyrightText}</CopyrightWrapper>;
};

export default Copyright;
